<template>
	<div class="full" style="background-color: white;">
		<el-container class="full">
			<el-aside width="250px" style="border-right: 1px solid #DCDFE6;">
				<emun-tree :field="name" ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-aside>
			<el-container class="full flex"
				style="position: relative;flex-direction: column;box-sizing: border-box;padding: 20px;">
				<el-header class="bread" style="position: relative;height: 30px;">
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="parentbread.length!=0">
						<el-breadcrumb-item v-for="(item,index) in parentbread" :key="index">{{item.name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<div v-else></div>
				</el-header>
				<el-main>
					<el-divider content-position="left">星空配置</el-divider>
					<el-form ref="form" :model="form" label-width="150px" v-loading="loading"
						style="flex: 1;position: relative;" v-if="currentitem && currentitem.children.length==0"
						element-loading-background="rgba(255, 255, 255, 0.5)">
						<el-form-item label="平台编码" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_plantcode" label="平台编码"></el-input>
						</el-form-item>
						<el-form-item label="部门编码" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_departmentcode" label="部门编码"></el-input>
						</el-form-item>
						<el-form-item label="支付宝银行账号【淘系】" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_zhifubao_bankaccount" label="支付宝银行账号"></el-input>
						</el-form-item>
						<el-form-item label="余利宝银行账号【淘系】" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_yulibao_bankaccount" label="余利宝银行账号"></el-input>
						</el-form-item>
						<el-form-item label="聚合银行账号【淘系】" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_juhe_bankaccount" label="聚合银行账号"></el-input>
						</el-form-item>
						<el-form-item label="网商银行【淘系】" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_wangshang_bankaccount" label="网商银行账号"></el-input>
						</el-form-item>
						<el-form-item label="钱袋宝【京东】" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_qiandaibao_bankaccount" label="聚合银行账号"></el-input>
						</el-form-item>
						<el-form-item label="账房【拼多多】" style="width: 600px;">
							<el-input size="mini" v-model="form.jindie_zhangfang_bankaccount" label="聚合银行账号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button style="float: right;" type="success" @click="onSubmit" size="mini">保存</el-button>
						</el-form-item>
					</el-form>
				</el-main>
			</el-container>
		</el-container>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	import Sortable from 'sortablejs'
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	export default {
		name: 'emunextend_tasktypeIndex',
		props: {
			name: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading: false,
				currentitem: null,
				emunid: 0,
				emuntTreeKey: Math.random(),
				parentbread: [],
				tableData: [],
				form: {
					jindie_plantcode: '',
					jindie_departmentcode: '',
					jindie_zhifubao_bankaccount:'',
					jindie_yulibao_bankaccount:'',
					jindie_juhe_bankaccount:'',
					jindie_wangshang_bankaccount:'',
					jindie_qiandaibao_bankaccount:'',
					jindie_zhangfang_bankaccount:''
				}
			}
		},
		watch: {
			emunid() {
				this.get()
			}
		},
		created() {
			let field = []
			for (let i in this.attr) {
				field.push(i)
			}
			if (field.length != 0) {
				this.$api.emunlist.list({
					field: field.join(',')
				}).then((res) => {
					res.forEach((item) => {
						this.attr[item.field].push(item)
					})
				})
			}
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			rowDrop() {
				this.$nextTick(() => {
					const xTable = this.$refs.cityWarehouseOrder
					this.sortable1 = Sortable.create(xTable.$el.querySelector(
						'.body--wrapper>.vxe-table--body tbody'), {
						handle: '.drag-btn',
						onEnd: ({
							newIndex,
							oldIndex
						}) => {

							const currRow = this.tableData.splice(oldIndex, 1)[0]
							this.tableData.splice(newIndex, 0, currRow)
							console.log(this.tableData)
						}
					})
				})
			},
			get() {
				if (!this.emunid) {
					this.$message.error('请选择商品')
					return
				}
				this.loading = true
				this.$api.emunextend_store.get(this.emunid).then((res) => {
					this.loading = false
					if (res) {
						this.form.jindie_plantcode = res.jindie_plantcode
						this.form.jindie_departmentcode = res.jindie_departmentcode
						this.form.jindie_zhifubao_bankaccount = res.jindie_zhifubao_bankaccount
						this.form.jindie_yulibao_bankaccount = res.jindie_yulibao_bankaccount
						this.form.jindie_juhe_bankaccount = res.jindie_juhe_bankaccount
						this.form.jindie_wangshang_bankaccount = res.jindie_wangshang_bankaccount
						
						this.form.jindie_qiandaibao_bankaccount = res.jindie_qiandaibao_bankaccount
						this.form.jindie_zhangfang_bankaccount = res.jindie_zhangfang_bankaccount
						
					} else {
						this.form.jindie_plantcode = null
						this.form.jindie_departmentcode = null
						this.form.jindie_zhifubao_bankaccount = null
						this.form.jindie_yulibao_bankaccount = null
						this.form.jindie_juhe_bankaccount = null
						this.form.jindie_wangshang_bankaccount = null
						
						this.form.jindie_qiandaibao_bankaccount = null
						this.form.jindie_zhangfang_bankaccount = null
					}

				})
			},
			onSubmit() {
				if (!this.emunid) {
					this.$message.error('请选类型')
					return
				}
				this.$api.emunextend_store.save({
					emunvalueid: this.emunid,
					jindie_plantcode: this.form.jindie_plantcode,
					jindie_departmentcode: this.form.jindie_departmentcode,
					jindie_zhifubao_bankaccount: this.form.jindie_zhifubao_bankaccount,
					jindie_yulibao_bankaccount: this.form.jindie_yulibao_bankaccount,
					jindie_juhe_bankaccount: this.form.jindie_juhe_bankaccount,
					jindie_wangshang_bankaccount: this.form.jindie_wangshang_bankaccount,
					jindie_qiandaibao_bankaccount: this.form.jindie_qiandaibao_bankaccount,
					jindie_zhangfang_bankaccount: this.form.jindie_zhangfang_bankaccount,
				}).then(() => {
					this.$message.success('操作成功')
				})

			},
			emuntTreeChange(e) {
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
		},
		components: {
			emunTree,

		}
	}
</script>